import React from 'react';

export const DropdownComponent = (props) => (
  <div>
    <label className="dropdownlist_label">{props.labelName}</label>
    <select
      className="dropdownlist"
      name={props.labelName}
      onChange={props.onSearchChange}
      disabled={props.disabled}
      value={props.value || ''} // Ensures controlled component
    >
      <option value="" disabled hidden>
        {props.default || 'Select...'}
      </option>

      {props.options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </select>
  </div>
);